import { Box, type SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import NeutralJerseyPlaceholder from '../../../atoms/NeutralJerseyPlaceholder';
import JerseyDisplay from '../../../molecules/JerseyDisplay';
import ParticipantAsset from '../../../atoms/ParticipantAsset';
import { mergeSx } from '../../../../utils/styles';
import { styles } from '../styles';
import type { PreMatchWidgetTeam } from '../types';

type TeamVisualProps = {
  competitionName?: string | null;
  team: PreMatchWidgetTeam;
  sx: SxProps<Theme>;
};

const renderFallbackVisual = (team: PreMatchWidgetTeam) => {
  if (team.jersey) {
    return <JerseyDisplay {...team.jersey} width='100%' height='100%' />;
  }

  return <NeutralJerseyPlaceholder />;
};

const TeamVisual = ({ competitionName, team, sx }: TeamVisualProps) => {
  const mergedSx = mergeSx(styles.teamVisual, sx);
  const fallback = renderFallbackVisual(team);

  return (
    <Box sx={mergedSx}>
      <ParticipantAsset
        competitionName={competitionName}
        fallback={fallback}
        participantId={team.participantId}
        participantName={team.name}
        size='100%'
      />
    </Box>
  );
};

export default TeamVisual;
